import React from 'react';
import { Sun, Moon, SlidersHorizontal, Notebook} from 'lucide-react';
import '../css/Buttons.css';

export function ThemeToggleButton({ theme, onToggleTheme }) {
  return (
    <button
      className="theme-btn"
      onClick={onToggleTheme}
      aria-label="Toggle theme"
      type="button"
    >
      {theme === 'light'
        ? <Moon size={28} strokeWidth={2} />
        : <Sun  size={28} strokeWidth={2} />
      }
    </button>
  );
}

export function FilterToggleButton({ onToggleControls, ...props }) {
  return (
    <button
      className="toggle-btn"
      onClick={onToggleControls}
      type="button"
      {...props}
    >
      {/* use your SVG gear or Lucide Settings icon here */}
        <SlidersHorizontal size={28} strokeWidth={2} />
    </button>
  );
}

export function NotebookButton({ onClick, ...props }) {
  return (
    <button
      className="notebook-btn"
      onClick={onClick}
      aria-label="Open notebook"
      type="button"
      {...props}
    >
      <Notebook size={20} strokeWidth={2} />
    </button>
  );
}
